import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';

@Injectable({ providedIn: 'root' })
export class BudgetService {

  url = ConfigService.toApiUrl('budgets/');

  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get<any>(`${this.url}`, ConfigService.addAction('list'));
  }

  summary() {
    return this.http.get<any>(`${ConfigService.toApiUrl('budgets-summary')}`, ConfigService.addAction('list'));
  }

  store(ressource: any) {
    return this.http.post<any>(`${this.url}`, ressource, ConfigService.addAction('add'));
  }

  update(id: any, ressource: any) {
    ressource['_method'] = 'patch';
    return this.http.post<any>(`${this.url}${id}`, ressource, ConfigService.addAction('edit'));
  }

  delete(id: any) {
    return this.http.delete<any>(`${this.url}${id}`, ConfigService.addAction('delete'));
  }

  get(id: any) {
    return this.http.get<any>(`${this.url}${id}`, ConfigService.addAction('show'));
  }

  setState(id: any, state: any) {
    return this.http.get<any>(`${ConfigService.toApiUrl('budgets-set-state')}/${id}/state/${state}`, ConfigService.addAction('status'));
  }
}
